// extracted by mini-css-extract-plugin
export default {"cards":"ResourcesSection-module__cards--eDi7o"};